import { render } from "./mls-disclaimer.vue?vue&type=template&id=175c5226"
import script from "./mls-disclaimer.vue?vue&type=script&lang=js"
export * from "./mls-disclaimer.vue?vue&type=script&lang=js"

import "./mls-disclaimer.vue?vue&type=style&index=0&id=175c5226&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-footer/mls-disclaimer.vue'],['render',render],['__file',"mls-disclaimer.vue"]])

export default __exports__